import React from "react";
import { FormattedMessage } from "react-intl";

import {
  RoamingDeviceNameCard,
  RoamingDeviceNameMobileCard,
} from "../roamingTables/RoamingDeviceNameCard";
import { ProtectionStatus } from "../roamingTables/ProtectionStatus";
import { showValue, timeSort } from "../../../components/table/helpers";
import { ClickAbsorber } from "../../../components/clickAbsorber/ClickAbsorber";
import { SingleRoamingDevicesDropdownActions } from "./components";
import { ellipsifyUUID } from "../../../helpers/devices.helpers";

export const ROAMING_COLUMNS = [
  {
    Header: <FormattedMessage id={"device_name_devices_table_header"} />,
    accessor: "name",
    cellClassName: "table__cell--overflow",
    SortingLabel: <FormattedMessage id={"device_name_devices_table_header"} />,
    Cell: ({
      row: {
        isExpanded,
        original: { name },
      },
    }) => <RoamingDeviceNameCard isExpanded={isExpanded} name={name} />,
  },
  {
    Header: <FormattedMessage id={"protection_status"} />,
    accessor: "protectionStatus",
    cellClassName: "table__cell--left",
    headerClassName: "table__cell--left",
    Cell: ({ row }) => (
      <ProtectionStatus status={row.original.protectionStatus} />
    ),
  },
  {
    Header: <FormattedMessage id={"last_seen_devices_table_header"} />,
    accessor: "lastSeen",
    sortType: timeSort,
    cellClassName: "color-table__cell",
    Cell: ({ row }) => <div>{showValue(row.original.lastSeen)}</div>,
  },
  {
    Header: <FormattedMessage id={"actions"} />,
    id: "actions",
    sortable: false,
    headerClassName: "table__cell--small-cell",
    cellClassName: "table__cell--center table__cell--overflow",
    Cell: ({
      row: {
        original: { identifier, fullName, name },
      },
    }) => (
      <ClickAbsorber>
        <SingleRoamingDevicesDropdownActions
          identifier={identifier}
          fullName={fullName}
          name={name}
        />
      </ClickAbsorber>
    ),
  },
];

export const ROAMING_COLUMNS_MOBILE = [
  {
    accessor: "name",
    SortingLabel: <FormattedMessage id={"device_name_devices_table_header"} />,
    cellClassName: "table__cell--overflow",
    Cell: ({
      row: {
        isExpanded,
        original: { name, protectionStatus, lastSeen, identifier },
      },
    }) => (
      <RoamingDeviceNameMobileCard
        isExpanded={isExpanded}
        name={name}
        lastSeen={lastSeen}
        protectionStatus={protectionStatus}
        aside={
          <SingleRoamingDevicesDropdownActions
            identifier={identifier}
            fullName={name || ellipsifyUUID(identifier)}
            name={name}
          />
        }
      />
    ),
  },
  {
    SortingLabel: <FormattedMessage id={"protection_status"} />,
    accessor: "protectionStatus",
  },
  {
    accessor: "lastSeen",
    sortType: timeSort,
    SortingLabel: <FormattedMessage id={"last_seen_devices_table_header"} />,
  },
];

export const SEARCH_KEYS = [
  "appStatus",
  "fullName",
  "identifier",
  "lastSeen",
  "model",
  "name",
  "os",
  "softwareVersion",
];

export const INITIAL_SORT = [{ id: "lastSeen", desc: true }];
